import React from "react";
import BulkAppointmentAddNewEntry from "./BulkAppointmentAddNewEntry";
import { Container, Grid, Paper } from "@mui/material";

export default function BulkAppointment() {
  return (
    <Container maxWidth="xl" sx={{ mt: 8, px: 1 }} disableGutters>
      <Grid container spacing={1} sx={{ pl: 3, pr: 3 }} display="flex">
        <Grid
          item
          xs={12}
          md={4}
          textAlign="left"
          alignSelf={"center"}
          mt={0.2}
        >
          <div className="pageHeader"> Bulk Appointment</div>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <Grid item xs={12} mb={5} sx={{ pl: 3, pr: 3, mt: 2 }}>
          <Paper elevation={3} variant="elevation">
            <BulkAppointmentAddNewEntry />
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}
